<template>
  <div class="w-full flex flex-row justify-start items-center">
    <span
      :class="
        colorName === 'white' ? 'bg-very-light-gray' : 'bg-dark-grayish-blue'
      "
      class="w-28 md:w-16 h-0.5 bg-dark-grayish-blue box-border mr-5"
    ></span>
    <div class="flex flex-col justify-start items-start">
      <span
        :class="
          colorName === 'white'
            ? 'text-very-light-gray'
            : 'text-dark-grayish-blue'
        "
        class="font-medium uppercase text-2.5 md:text-3xl"
        >{{ tagName }}</span
      >
      <span
        v-if="tagNumber"
        :class="
          colorName === 'white'
            ? 'text-very-light-gray'
            : 'text-dark-grayish-blue'
        "
        class="number text-2.5 xl:text-4xl md:text-3xl uppercase font-medium"
        >{{ tagNumber }}</span
      >
      <span v-if="subTag" class="text-light-violet text-2.2 uppercase">{{
        subTag
      }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'section-tag',
  props: ['tagName', 'tagNumber', 'colorName', 'subTag'],
};
</script>

<style></style>
